export const SAVE_VIDEO_LINK = 'SAVE_VIDEO_LINK';
export const UPLOAD_VIDEO_LINK = 'UPLOAD_YOUTUBE_LINK';
export const UPDATE_HAS_SNACK_BAR = 'UPDATE_YOUTUBE_LINK';
export const DELETE_VIDEO_LINK = 'DELETE_VIDEO_LINK';
export const FETCH_VIDEO_LINK = 'FETCH_VIDEO_LINK';
